import { useEffect, useRef, useState } from 'react'
import { Navigation } from 'swiper/modules';
import axios from 'axios'

import { Swiper, SwiperSlide } from 'swiper/react';

export interface ITileProps {
	data: any,
	altStyle?: boolean,
	isLoggedIn: boolean
	saved?: boolean | string
	toggleToSaved?: (id: string) => void
}

async function sendRequest(url, { arg }: { arg: { username: string }}) {
	return fetch(url, {
		method: 'POST',
		body: JSON.stringify(arg)
	}).then(res => res.json())
}

const Tile = ({ data, altStyle, toggleToSaved, isLoggedIn, saved }: ITileProps) => {
	const [isSubmitting, setIsSubmitting] = useState(false)

	const slides = altStyle ? JSON.parse(data?.heroImageUrls) || [] : data?.heroImageUrls || []

	const favorite = async () => {
		setIsSubmitting(true)
		if (!saved) {
			toggleToSaved(data?.id)
			axios.post('/api/property/save',
				'propertyId='+ data?.id
			)
			.then(function (response) {
				console.log(response);
				setIsSubmitting(false)
			})
			.catch(function (error) {
				console.log(error);
			});
		} else {
			toggleToSaved(data?.id)
			axios.post('/api/property/remove',
				'propertyId='+ data?.id
			)
			.then(function (response) {
				console.log(response);
				setIsSubmitting(false)
			})
			.catch(function (error) {
				console.log(error);
			});
		}

	}

	return (
		<div className={["listing-tile", !isLoggedIn && data?.offMarketProperty ? 'listing-tile-secret' : ''].join(' ')}>
			<div className="listing-image">
				{!isLoggedIn && data?.offMarketProperty ?
					<a href={"/account/secret-properties/"}>
						<img src={`${slides[0]}?width=600&height=400&mode=crop&quality=70&blur=90&sigma=10&threshold=10`} className='slide-blur' alt="Listing" />
					</a>
				:
					<Swiper
						modules={[Navigation]}
						loop={true}
						slidesPerView={1}
						navigation
					>
						{(slides && slides?.length > 0) && slides?.map((slide: any, index: number) => (
							<SwiperSlide key={index}>
								<a href={`${window.location.pathname.replace(/\/$/, "")}/${data?.urlSegment}`}>
									<img src={`${slide}?width=600&height=400&mode=crop&quality=70`} alt="Listing" />
								</a>
							</SwiperSlide>
						))}
					</Swiper>
				}
				{(!(data?.offMarketProperty) && data?.prestigeProperty) && <span className='location-badge'>PRESTIGE</span>}
				{data?.offMarketProperty && <span className='location-badge'>SECRET</span>}
			</div>
			{(!isLoggedIn && data?.offMarketProperty) ?
				<div className="listing-account-login">
					<h5>Create an account to view this secret property.</h5>
					<a href="/account/secret-properties/" className='btn btn--wide brand accent'>REGISTER / LOGIN</a>
				</div>
			:
				<div className={["listing-details", !!altStyle ? 'listing-details-alt' : ''].join(' ')}>
					<div className="listing-title">
						<a className='h5' href={`${window.location.pathname.replace(/\/$/, "")}/${data?.urlSegment}`}>{data?.priceGuide}</a>
						{isLoggedIn ?
							<button type="button" onClick={favorite} disabled={isSubmitting} className='save-button'>
								{saved ?
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M20.1347 13.3508L12.7037 20.7105C12.314 21.0965 11.686 21.0965 11.2963 20.7105L3.79929 13.2855C3.20723 12.7084 2.74079 12.0153 2.42925 11.2494C2.11714 10.4822 1.96727 9.65862 1.98908 8.8306C2.01089 8.00257 2.20391 7.18804 2.55598 6.43828C2.90806 5.68852 3.41156 5.01978 4.03478 4.47417C4.658 3.92856 5.38744 3.5179 6.17717 3.26805C6.9669 3.0182 7.7998 2.93458 8.62344 3.02244C9.44707 3.1103 10.2436 3.36774 10.9628 3.77856C11.3369 3.99221 11.6858 4.24493 12.0041 4.5318C12.3221 4.2484 12.6701 3.99891 13.0429 3.78814C13.7616 3.38168 14.5565 3.12796 15.3778 3.04284C16.1992 2.95773 17.0292 3.04305 17.8161 3.29349C18.6029 3.54392 19.3296 3.95406 19.9506 4.49825C20.5716 5.04244 21.0736 5.70896 21.4252 6.45609C21.7768 7.20322 21.9704 8.01488 21.9939 8.84027C22.0174 9.66566 21.8702 10.487 21.5617 11.2529C21.2531 12.0188 20.7898 12.7128 20.2007 13.2914C20.1794 13.3124 20.1573 13.3322 20.1347 13.3508Z" fill="inherit"/>
									</svg>
								:
									<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fillRule="evenodd" clipRule="evenodd" d="M8.41111 5.17796C7.86202 5.11939 7.30675 5.17514 6.78026 5.34171C6.25378 5.50827 5.76748 5.78205 5.352 6.14579C4.93652 6.50952 4.60086 6.95535 4.36614 7.45519C4.13142 7.95503 4.00274 8.49805 3.9882 9.05007C3.97366 9.60208 4.07358 10.1511 4.28165 10.6626C4.48973 11.1741 4.80146 11.637 5.19721 12.0221L5.20353 12.0283L5.2035 12.0283L11.9998 18.7594L18.7961 12.0283C18.8168 12.0078 18.8382 11.9883 18.8602 11.97C19.2239 11.5969 19.5115 11.1562 19.7064 10.6724C19.9121 10.1618 20.0102 9.61421 19.9945 9.06395C19.9789 8.51369 19.8498 7.97258 19.6154 7.47449C19.381 6.97641 19.0463 6.53206 18.6323 6.16927C18.2183 5.80648 17.7339 5.53305 17.2093 5.36609C16.6847 5.19914 16.1314 5.14225 15.5838 5.199C15.0363 5.25574 14.5063 5.42489 14.0272 5.69586C13.548 5.96684 13.1299 6.3338 12.7991 6.77378C12.6096 7.02579 12.3123 7.17368 11.997 7.1728C11.6817 7.17192 11.3853 7.02239 11.1972 6.76932C10.8678 6.32612 10.4502 5.95593 9.97071 5.68205C9.49121 5.40817 8.9602 5.23654 8.41111 5.17796ZM20.1345 13.5177L12.7035 20.8773C12.3138 21.2633 11.6859 21.2633 11.2961 20.8773L3.7991 13.4523C3.20704 12.8752 2.7406 12.1821 2.42907 11.4162C2.11696 10.649 1.96709 9.82542 1.9889 8.9974C2.01071 8.16938 2.20373 7.35485 2.5558 6.60509C2.90787 5.85533 3.41137 5.18659 4.0346 4.64098C4.65782 4.09537 5.38726 3.68471 6.17699 3.43486C6.96671 3.18501 7.79962 3.10138 8.62325 3.18925C9.44689 3.27711 10.2434 3.53455 10.9627 3.94537C11.3367 4.15902 11.6856 4.41174 12.0039 4.69861C12.3219 4.41521 12.67 4.16572 13.0427 3.95495C13.7614 3.54849 14.5563 3.29477 15.3777 3.20965C16.199 3.12453 17.029 3.20986 17.8159 3.4603C18.6027 3.71073 19.3294 4.12087 19.9504 4.66506C20.5714 5.20925 21.0735 5.87577 21.4251 6.6229C21.7766 7.37003 21.9702 8.18169 21.9937 9.00708C22.0172 9.83246 21.8701 10.6538 21.5615 11.4197C21.253 12.1856 20.7896 12.8796 20.2005 13.4582C20.1792 13.4792 20.1572 13.499 20.1345 13.5177Z" fill="inherit"/>
									</svg>
								}
							</button>
						:
							<a href={`/account/register/?id=${data?.id}`}>
								<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fillRule="evenodd" clipRule="evenodd" d="M8.41111 5.17796C7.86202 5.11939 7.30675 5.17514 6.78026 5.34171C6.25378 5.50827 5.76748 5.78205 5.352 6.14579C4.93652 6.50952 4.60086 6.95535 4.36614 7.45519C4.13142 7.95503 4.00274 8.49805 3.9882 9.05007C3.97366 9.60208 4.07358 10.1511 4.28165 10.6626C4.48973 11.1741 4.80146 11.637 5.19721 12.0221L5.20353 12.0283L5.2035 12.0283L11.9998 18.7594L18.7961 12.0283C18.8168 12.0078 18.8382 11.9883 18.8602 11.97C19.2239 11.5969 19.5115 11.1562 19.7064 10.6724C19.9121 10.1618 20.0102 9.61421 19.9945 9.06395C19.9789 8.51369 19.8498 7.97258 19.6154 7.47449C19.381 6.97641 19.0463 6.53206 18.6323 6.16927C18.2183 5.80648 17.7339 5.53305 17.2093 5.36609C16.6847 5.19914 16.1314 5.14225 15.5838 5.199C15.0363 5.25574 14.5063 5.42489 14.0272 5.69586C13.548 5.96684 13.1299 6.3338 12.7991 6.77378C12.6096 7.02579 12.3123 7.17368 11.997 7.1728C11.6817 7.17192 11.3853 7.02239 11.1972 6.76932C10.8678 6.32612 10.4502 5.95593 9.97071 5.68205C9.49121 5.40817 8.9602 5.23654 8.41111 5.17796ZM20.1345 13.5177L12.7035 20.8773C12.3138 21.2633 11.6859 21.2633 11.2961 20.8773L3.7991 13.4523C3.20704 12.8752 2.7406 12.1821 2.42907 11.4162C2.11696 10.649 1.96709 9.82542 1.9889 8.9974C2.01071 8.16938 2.20373 7.35485 2.5558 6.60509C2.90787 5.85533 3.41137 5.18659 4.0346 4.64098C4.65782 4.09537 5.38726 3.68471 6.17699 3.43486C6.96671 3.18501 7.79962 3.10138 8.62325 3.18925C9.44689 3.27711 10.2434 3.53455 10.9627 3.94537C11.3367 4.15902 11.6856 4.41174 12.0039 4.69861C12.3219 4.41521 12.67 4.16572 13.0427 3.95495C13.7614 3.54849 14.5563 3.29477 15.3777 3.20965C16.199 3.12453 17.029 3.20986 17.8159 3.4603C18.6027 3.71073 19.3294 4.12087 19.9504 4.66506C20.5714 5.20925 21.0735 5.87577 21.4251 6.6229C21.7766 7.37003 21.9702 8.18169 21.9937 9.00708C22.0172 9.83246 21.8701 10.6538 21.5615 11.4197C21.253 12.1856 20.7896 12.8796 20.2005 13.4582C20.1792 13.4792 20.1572 13.499 20.1345 13.5177Z" fill="currentColor"/>
								</svg>
							</a>
						}
					</div>
					<div className="listing-description">
						<a href={`${window.location.pathname.replace(/\/$/, "")}/${data?.urlSegment}`}>{data?.thumbTitle}</a>
						{!altStyle && <h6>{data?.thumbSubTitle}</h6>}
					</div>
					{data?.segment == "commercial" ?
						<p className='listing-info'>{data?.squareMeter !== "0" ? `${data?.squareMeter} Square Meters` : ""}{data?.category ? ` - ${data?.category}` : ''}</p>
					:
						<p className='listing-info'>{data?.beds} Bed{data?.beds > 1 ? 's' : ''} - {data?.baths} Bath{data?.baths > 1 ? 's' : ''}{data?.cars > 0 ? ` - ${data?.cars} Parking` : ''}</p>
					}
				</div>
			}
		</div>
	)
}

export default Tile
